/**
* API FACEBOOK
*/

function statusChangeCallback(response){
    if(response.status === 'connected'){
        $(".fb-share-login").css({ 'display' : 'none' });
        $(".fb-share-btn").css({ 'display' : 'block' });
        $(".fb-share-btn").on('click', function(e){
            e.preventDefault();
            FB.ui({
                method : 'share',
                href : 'http://haleyreinhart.com',
            },
            // callback
            function(response){
                if(response && !response.error_message){
                    $(".fb-share-btn").css({ 'display' : 'none' });
                    $(".fb-share-success").css({ 'display' : 'block' });
                }
            });
        });
        /**
        // récupérer des informations
        FB.api('/me', function(response){
            console.log('Good to see you, ' + response.name + '.');
        });
        // envoyer un message
        FB.api('/me/feed', 'post', { message: 'Bonjour!' });
        */
    }
    else if(response.status === 'not_authorized'){

    }
    else{

    }
}

function checkLoginState(){
    FB.getLoginStatus(function(response){
      statusChangeCallback(response);
    });
}

window.fbAsyncInit = function(){
    FB.init({
      appId      : '434635600054723',
      cookie : true,
      xfbml      : true,
      version    : 'v2.8'
    });

    FB.getLoginStatus(function(response){
        statusChangeCallback(response);
    });
};

(function(d, s, id){
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = "//connect.facebook.net/fr_FR/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));
